import script from "./Case.vue?vue&type=script&setup=true&lang=js"
export * from "./Case.vue?vue&type=script&setup=true&lang=js"

import "./Case.vue?vue&type=style&index=0&id=bcb8883a&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcb8883a"]])

export default __exports__